/**
 * Pet Tips Resolver — определяет, КАКИЕ ключи советов подходят под введённые
 * данные калькулятора. Ключи совпадают с существующим quiz.insight в locale-
 * файлах. Текст советов здесь не хранится — рендерится через `| t` в шаблоне.
 */
(function (global) {
  /**
   * @param {Object} p
   * @param {'dog'|'cat'} p.species
   * @param {string} p.age
   * @param {string} [p.breedSize]
   * @param {boolean} [p.sterilized]
   * @param {string} [p.lifestyle]
   * @param {string} [p.goal] 'maintain'|'weight_loss'|'weight_gain'|'lactating'
   * @returns {string[]}
   */
  function getRelevantTipKeys(p) {
    var species = p.species;
    var age = p.age;
    var breedSize = p.breedSize;
    var sterilized = !!p.sterilized;
    var lifestyle = p.lifestyle;
    var goal = p.goal;

    var keys = [];

    if (age === 'kitten') keys.push('kitten');
    if (age === 'puppy') keys.push('puppy');
    if (age === 'junior') keys.push('junior');
    if (age === 'adult') keys.push('adult');
    if (age === 'senior') keys.push('senior');
    if (age === 'all') keys.push('all_ages');

    if (species === 'dog' && breedSize) {
      if (breedSize === 'small') keys.push('small_breed');
      if (breedSize === 'medium') keys.push('medium_breed');
      if (breedSize === 'large') keys.push('large_breed');
      if (breedSize === 'all') keys.push('all_breeds');
    }

    if (sterilized) keys.push('sterilized');
    if (lifestyle === 'indoor') keys.push('indoor');
    if (lifestyle === 'active') keys.push('active');
    if (lifestyle === 'standard') keys.push('standard_lifestyle');

    if (goal === 'weight_loss') keys.push('weight_loss');
    if (goal === 'weight_gain') keys.push('weight_gain');
    if (goal === 'lactating') keys.push('lactating');

    return keys;
  }

  global.PetTipsResolver = {
    getRelevantTipKeys: getRelevantTipKeys,
  };
})(window);